import { useMemo } from 'react';
import { FilterableField } from 'components/organisms/tasks/fields';
import { excludedProjectFieldsForFilter } from 'utils/project-fields/constants';
import { useProjectFieldsAsFilterableFields } from 'utils/project-fields/use-project-fields-as-filterable-fields';

export const useSuTemplateProjectFilterFields = (): [
  fields: FilterableField[],
  isFieldsLoading: boolean,
] => {
  const { fields: allFields, loading: isFieldsLoading } =
    useProjectFieldsAsFilterableFields();
  const fields = useMemo(
    () =>
      isFieldsLoading
        ? []
        : allFields.filter(
            (x) => !excludedProjectFieldsForFilter.includes(x.fieldName),
          ),
    [allFields, isFieldsLoading],
  );

  return [fields, isFieldsLoading];
};
